export const TEST_FAQ_LANGUAGE = {
  CARRIER: [
    {
      question: "How can Genomic Life's Navigation team help me?",
      answer:
        "Genomic Life is here to support your health journey. Our expert navigation team can help you: <br/><br/> &#8226; Connect you with a genetic counselor or pharmacist.<br/> &#8226; Direct you to health resources.<br/> &#8226; Answer other questions you may have.<br/><br/>Contact us at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>."
    },
    {
      question: "What is Carrier screening?",
      answer:
        "A carrier screen can tell you if you carry changes in your genes that you could pass to your children. These changes are not likely to affect your health but could increase the risk of your child inheriting a genetic condition. Carrier screening is most useful for family planning when both reproductive partners take the carrier screening test."
    },
    {
      question: "How do I speak with my healthcare provider about my results?",
      answer:
        "It is important to share your test results with your healthcare provider. Your healthcare provider can help you understand your results and what they mean for you and your partner for family planning purposes."
    },
    {
      question: "Should my partner have Carrier screening?",
      answer:
        "Carrier screening results are the most useful when both reproductive partners take the test. The test results can then be compared between the partners to determine if they both have a genetic change in the same gene. If there is a common finding in both partners' carrier screening reports, then the couple will be at a 25% risk of having a child with that disorder.<br/><br/>It is important to share your results with your healthcare provider. Genomic Life's member portal has simple steps to allow you to download your results. Genomic Life can schedule a telephone visit with a genetic counselor to talk about your results and what they mean for your family. Contact us at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>"
    },
    {
      question: "Does Carrier Screening tell me about my health?",
      answer:
        "A carrier screening test generally does not tell you about your own personal health. It will look at whether you carry changes in your genes that you can pass down to each of your children. If you pass a genetic change down to your child, dependent on the status of your reproductive partner, your child may be at risk for inheriting a genetic condition.<br/><br/>Anyone who is pregnant, or planning to become pregnant, should consider having a carrier screening test. It is also important to have your reproductive partner get a carrier screening test as well."
    }
  ],
  PGX: [
    {
      question: "How can Genomic Life's Navigation team help me?",
      answer:
        "Genomic Life is here to support your health journey. Our expert navigation team can help you: <br/><br/> &#8226; Connect you with a genetic counselor or pharmacist.<br/> &#8226; Direct you to health resources.<br/> &#8226; Answer other questions you may have.<br/><br/>Contact us at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>."
    },
    {
      question: "What is a Pharmacogenomic test?",
      answer:
        "A Pharmacogenomic (PGx) test is a test that looks at how your genes can affect the way your body reacts to and processes medications. Changes in your genes can influence how well a medication works for you or if it causes side effects. This information can help your healthcare provider tailor your medications based on your genes."
    },
    {
      question: "How do I speak with my healthcare provider about my results?",
      answer:
        "It is important to share your test results with your healthcare provider. Your healthcare provider can help you understand your results and what they mean for you. Based on talking with your healthcare provider, they may adjust your medication or dose based on the results from this pharmacogenomic test. These results may also be helpful if your healthcare provider wants to start you on any new medications.<br/><br/>Genomic Life's member portal has simple steps to allow you to download or print out your results so you may share them with your healthcare provider. This is a great way to start a conversation with your healthcare provider."
    },
    {
      question: "Will my results change my medications?",
      answer:
        "The results from your pharmacogenomic test could change how your healthcare provider prescribes your medication. If the results show that you could be at higher risk for adverse drug reactions, a pharmacist or your healthcare provider may adjust your medicine or the dose you take.<br/><br/>It is important to share your test results with your healthcare provider. Your healthcare provider can help you understand your results and what they mean for you. Genomic Life's member portal has simple steps to allow you to download your results so you may share them with your healthcare provider."
    }
  ],
  GHS: [
    {
      question: "What is the Genetic Health Screen?",
      answer:
        "The Genetic Health Screen (GHS) is a test that looks at parts of your DNA (genes).  It can give you and your healthcare provider useful information.  The test may tell you about whether you have an increased risk of developing a condition such as cancer, cardiovascular disease, or other disorders. The conditions tested for with this test may have medical steps or preventive measures you can take to stay healthy or catch the condition at an early, more treatable stage. The results should be shared with your healthcare provider."
    },
    {
      question: "What are the possible results?",
      answer:
        "The possible results from a Genetic Health Screen are:<br/><br/><strong>Positive or Increased Risk:</strong> This means the test found a change in at least one of the genes tested that raises your chances of getting a health condition. This result means you are at a higher risk of getting a certain type of condition than the general population. More frequent screening and prevention strategies can help.<br/><br/><strong>Potentially Positive:</strong> This means the test found something that needs follow-up testing. You could be at risk for a condition, but the laboratory needs more information to be able to confirm this. They might need to test one or more members of your family to help determine your personal risk.<br/><br/><strong>Carrier:</strong> This means the test found a change in a gene(s) that will not raise your risk of disease, but that could be passed on to your children. No other changes were found with this test that could impact your personal risk of disease. Your risk can be influenced by family history, lifestyle factors, exposures and other genetic risk factors not tested for.<br/><br/><strong>Negative:</strong> This means that no changes were found in the tested genes that are known to increase the risk of certain conditions. With a negative result, you are at least at an average risk for conditions like cancer and cardiovascular disease. However, risk can be influenced by family history, lifestyle factors, exposures and other genetic risk factors not tested for."
    },
    {
      question: "How do I speak with my healthcare provider about my results?",
      answer:
        "It is important to share your test results with your healthcare provider. Your healthcare provider can help you understand your results and what they mean for you. Your healthcare provider can also talk about any impact your results may have on your family, and what your next steps may be to keep you healthy. It is important to stay up to date with routine screening and health check guidelines.<br/><br/>Genomic Life's member portal has simple steps to allow you to download or print out your results so you may share them with your healthcare provider. This is a great way to start a conversation with your healthcare provider."
    },
    {
      question: "What are my next steps if my result is Positive? Negative?",
      answer:
        "If your result is <strong>positive</strong>, a member of our team will reach out to you to review and discuss next steps.<br/><br/>You may also want to speak with a genetic counselor about your results. Genomic Life can schedule a telephone visit with a certified genetic counselor to talk about your results and next steps. Contact us at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>.<br/><br/>If your result is <strong>negative</strong>, we recommend that you share your results with your provider. Lifestyle, family history, environment and other factors not tested for can also impact your risk. Genomic Life encourages you to create a plan with your provider to stay healthy. This includes age and sex-appropriate screenings<br/><br/>Regardless of your result, we recommend that you:<br/><br/> &#8226; Download your results.<br/> &#8226; Share them with your healthcare provider.<br/> &#8226; Talk with your provider about actions you can take.<br/> &#8226; Create a plan."
    },
    {
      question: "I have a positive result.  What does that mean for my family?",
      answer:
        "It's a good idea to talk with your relatives about your results. A positive result means that they can access free testing for 150 days after your report date.  Family testing is offered through Invitae, the lab that performed the testing. The testing offered is limited to the positive findings in your report. A healthcare provider must order this test for your family member.  In most cases, family testing is limited to those over 18, but some exceptions apply.  Genomic Life can provide resources to help your relatives with this process. Please visit www.invitae.com/family for more information. You can also contact our team at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>"
    },
    {
      question: "How can Genomic Life help me?",
      answer:
        "Our expert navigation team is here to support you, your health, and well-being. We can help you: <br/><br/> &#8226; Understand your results and next steps<br/> &#8226; Talk with your provider<br/> &#8226; Feel empowered and make informed choices<br/> &#8226; Share your results with family<br/> &#8226; Connect with resources<br/><br/>Contact us at <a href='mailto:navigation@genomiclife.com'>navigation@genomiclife.com</a>."
    },
    {
      question: "What happens when there are updates to a report?",
      answer:
        "Invitae, the lab that performed this testing, will update this report if new information makes any changes that are important for your health.<br/><br/>You can always come back to Genomic Life to see any file updates."
    }
  ]
};

/**
 * Centralized test kit metadata configuration
 * All test kit information is defined here in one place.
 *
 * When adding a new test kit, add an entry here with all metadata.
 * The helper functions below will derive the legacy mappings automatically.
 */
export const TEST_KIT_METADATA = {
  // GHS - Invitae
  "3cf65de6-41f9-4e98-a256-231c871e3377": {
    test_uuid: "3cf65de6-41f9-4e98-a256-231c871e3377",
    glTestType: "GHS",
    test_name: "Genetic Health Screen",
    name: "Genetic Health Screen",
    lab: "Invitae",
    description:
      "Understand your health with this accurate, medical-grade DNA test that identifies a predisposition to developing hereditary cancers, cardiovascular diseases, and other significant conditions.",
    shortDescription:
      "This medical-grade test can reveal your risk for developing certain kinds of cancer, heart disease, and other actionable conditions.",
    purpose:
      "Offers insight into risks for hereditary cancers, specific heart diseases, and other actionable conditions.",
    header: "What is a genetic health screen?",
    chipInformation: undefined,
    order: 3
  },
  "dna-visit-ghs": {
    test_uuid: "dna-visit-ghs",
    glTestType: "GHS",
    test_name: "Genetic Health Screen",
    name: "Genetic Health Screen",
    lab: "Invitae",
    description:
      "Understand your health with this accurate, medical-grade DNA test that identifies a predisposition to developing hereditary cancers, cardiovascular diseases, and other significant conditions.",
    shortDescription:
      "This medical-grade test can reveal your risk for developing certain kinds of cancer, heart disease, and other actionable conditions.",
    purpose:
      "Offers insight into risks for hereditary cancers, specific heart diseases, and other actionable conditions.",
    header: "What is a genetic health screen?",
    chipInformation: undefined,
    order: 3
  },

  // Carrier - Myriad
  "49980d6c-bc0e-43c0-8139-150c4d47ccd9": {
    test_uuid: "49980d6c-bc0e-43c0-8139-150c4d47ccd9",
    glTestType: "CARRIER",
    test_name: "Carrier Screening",
    name: "Comprehensive Carrier Screen",
    lab: "Myriad",
    description:
      "Receive answers and inform family planning with carrier screening that examines your genetics to identify a potential risk of having a child affected by a genetic condition.",
    shortDescription:
      "This test helps with family planning for you and your partner to understand changes in your genes that don't affect you but may affect your child.",
    purpose:
      "Supports informed family planning by identifying genetic conditions that could be passed to your child.",
    header: "Are you and your reproductive partner carriers?",
    chipInformation: "Planning on having a child?",
    order: 2
  },
  "dna-visit-carrier": {
    test_uuid: "dna-visit-carrier",
    glTestType: "CARRIER",
    test_name: "Carrier Screening",
    name: "Comprehensive Carrier Screen",
    lab: "Myriad",
    description:
      "Receive answers and inform family planning with carrier screening that examines your genetics to identify a potential risk of having a child affected by a genetic condition.",
    shortDescription:
      "This test helps with family planning for you and your partner to understand changes in your genes that don't affect you but may affect your child.",
    purpose:
      "Supports informed family planning by identifying genetic conditions that could be passed to your child.",
    header: "Are you and your reproductive partner carriers?",
    chipInformation: "Planning on having a child?",
    order: 2
  },

  // PGx - OneOme (current)
  "ea4dd20c-52b8-4e3d-9fdb-9796bc4a50a8": {
    test_uuid: "ea4dd20c-52b8-4e3d-9fdb-9796bc4a50a8",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "OneOme",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 1
  },
  "dna-visit-pgx": {
    test_uuid: "dna-visit-pgx",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "OneOme",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 1
  },

  // PGx - Invitae (legacy)
  "8845bdbe-330e-4afc-82ed-f1cfa1d808ad": {
    test_uuid: "8845bdbe-330e-4afc-82ed-f1cfa1d808ad",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "Invitae",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 1
  },

  // PGx - Legacy
  "71957dc2-ee1e-4d9d-bc72-507aeb0ff992": {
    test_uuid: "71957dc2-ee1e-4d9d-bc72-507aeb0ff992",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "OneOme",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 1
  },
  "429fc77b-c1c1-455e-937c-de67db27e058": {
    test_uuid: "429fc77b-c1c1-455e-937c-de67db27e058",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "OneOme",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 1
  },

  // PGx - AccessDx
  "dna-visit-accessdx-pgx": {
    test_uuid: "dna-visit-accessdx-pgx",
    glTestType: "PGX",
    test_name: "Pharmacogenomics (PGx)",
    name: "Pharmacogenomics Panel",
    lab: "AccessDx",
    description:
      "Learn what drugs work for you with a PGx test that uncovers how you metabolize and respond to medications. This knowledge helps reduce adverse drug reactions.",
    shortDescription:
      "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
    purpose:
      "Supports understanding how your genetics affect your response to medications.",
    header: "Have you heard of PGx?",
    chipInformation: "Taking medications?",
    order: 4
  }
};

/**
 * Helper: Get metadata for a test by UUID
 */
export const getTestKitMetadata = (test_uuid) => {
  return TEST_KIT_METADATA[test_uuid];
};

/**
 * Legacy mappings - derived from TEST_KIT_METADATA for backward compatibility
 */
export const TEST_DESCRIPTION_LANGUAGE = {
  CARRIER:
    "This test helps with family planning for you and your partner to understand changes in your genes that don't affect you but may affect your child.",
  PGX:
    "This test provides information that can help you and your provider choose the medication and dosage that's right for you.",
  GHS: ""
};

export const TEST_TYPE_BY_UUID = Object.entries(TEST_KIT_METADATA).reduce(
  (acc, [uuid, metadata]) => {
    acc[uuid] = metadata.glTestType;
    return acc;
  },
  {}
);

export const TEST_NAME_BY_UUID = Object.entries(TEST_KIT_METADATA).reduce(
  (acc, [uuid, metadata]) => {
    acc[uuid] = metadata.name;
    return acc;
  },
  {}
);

export const getFaqLanguageForTestByTestUUID = (testUUID) => {
  return TEST_FAQ_LANGUAGE[TEST_TYPE_BY_UUID[testUUID]];
};

export const getDescriptionLanguageForTestByTestUUID = (testUUID) => {
  return TEST_DESCRIPTION_LANGUAGE[TEST_TYPE_BY_UUID[testUUID]];
};

export const getDescriptionLanguageForTestByTestDescription = (description) => {
  if (description.uuid) {
    return getDescriptionLanguageForTestByTestUUID(description.uuid);
  } else {
    return TEST_DESCRIPTION_LANGUAGE[description.name];
  }
};

export const getFaqLanguageForTestByTestDescription = (description) => {
  if (description.uuid) {
    return getFaqLanguageForTestByTestUUID(description.uuid);
  } else {
    return TEST_FAQ_LANGUAGE[description.name];
  }
};

export const getTestNameFromOrderDescription = (description) => {
  if (description.uuid) {
    return TEST_NAME_BY_UUID[description.uuid];
  } else {
    return "Genetic Test";
  }
};
